import { render, staticRenderFns } from "./ContractorsTendersTab.vue?vue&type=template&id=062698d4&"
import script from "./ContractorsTendersTab.vue?vue&type=script&lang=js&"
export * from "./ContractorsTendersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports